import { createStyles, makeStyles } from "@material-ui/core";
import {
    JobStatusLabel,
    MobilePage,
    MobilePageActions,
    MobilePageSection,
    RelodeTheme,
    Text,
} from "@relode/core";
import * as React from "react";

import { useJobContext } from "../../../_infra";
import { JobActionsMobile } from "./../jobActions/jobActionsMobile";
import { JobDetailsProps } from "./jobDetailsProps";
import { JobInsights } from "./jobInsights";
import { JobOrder } from "./jobOrder";
import { JobOverview } from "./jobOverview";
import { TeamMembersMobile } from "./teamMembersMobile";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            addIcon: {
                marginRight: theme.spacing(1),
            },
            button: {
                minWidth: 180,
            },
            statusLabel: {
                display: "flex",
                alignItems: "center",
            },
            location: {
                marginRight: theme.spacing(1),
            },
        }),
    { name: "JobDetailsMobile" }
);

export const JobDetailsMobile = (props: JobDetailsProps) => {
    const classes = useStyles(props);
    const {
        state: {
            data: { job, currentJobId },
            ui: { isJobLoading },
        },
    } = useJobContext();

    const {
        handleMessageComposer,
        handleOpenTeamMembersModal,
        handleDeleteTeamMember,
        handleEditTeamMember,
        handleChangeJobStatus,
        nextPossibleStatuses,
        handleShareJob,
        handleCopyJob,
        backUrl,
        handleEditJob,
    } = props;

    return (
        <MobilePage
            pageTitle={job.details?.jobName}
            showTabs={true}
            defaultSection="details"
            isBusy={isJobLoading}
            actions={
                <MobilePageActions
                    backUrl={backUrl ? backUrl : "/jobs"}
                    title={job.details ? job.details.jobName : "n/a"}
                    statusLabel={
                        job.details ? (
                            <div className={classes.statusLabel}>
                                <Text
                                    dataCy="locationName"
                                    className={classes.location}
                                >
                                    {job.details.location?.locationName}
                                </Text>
                                <JobStatusLabel
                                    title={job.details.jobStatus.description}
                                    jobStatus={job.details.jobStatus}
                                />
                            </div>
                        ) : null
                    }
                >
                    <JobActionsMobile
                        shareAction={
                            job.details.canShare ? handleShareJob : null
                        }
                        messageAction={handleMessageComposer}
                        jobStatusAction={handleChangeJobStatus}
                        availableJobStatuses={nextPossibleStatuses}
                        jobCopyAction={handleCopyJob}
                        jobEditAction={handleEditJob}
                    />
                </MobilePageActions>
            }
        >
            <MobilePageSection label="details" id="details">
                <JobOverview job={job} />
            </MobilePageSection>

            <MobilePageSection label="team" id="team">
                <TeamMembersMobile
                    team={job.team}
                    handleOpenTeamMembersModal={handleOpenTeamMembersModal}
                    handleDeleteTeamMember={handleDeleteTeamMember}
                    handleEditTeamMember={handleEditTeamMember}
                    jobStatus={job.details.jobStatus}
                />
            </MobilePageSection>
            {job.details.canViewSalary ? (
                <MobilePageSection label="order" id="order">
                    <JobOrder order={job.order} overview={job.details} />
                </MobilePageSection>
            ) : null}
            <MobilePageSection
                label="insights"
                id="insights"
                count={job.details.totalAvailableCandidateCount}
            >
                <JobInsights />
            </MobilePageSection>
        </MobilePage>
    );
};
